/**
 * @generated SignedSource<<60583b4063a525dbafc4900d25e417e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type CANT_DELETE_PROJECT_REASON = "HAS_LOCKED_TIME" | "HAS_INVOICED_TIME" | "HAS_OTHER_PEOPLES_TIME_REGS" | "UNKNOWN" | "%future added value";
export type PERIODICITY = "DAILY" | "WEEKLY" | "MONTHLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "UNCAPPED" | "CAPPED" | "FIXED_PRICE" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectSettingsPage_project$data = {
  readonly id: string;
  readonly companyProjectId: number | null;
  readonly portalConfig: {
    readonly showInClientPortal: boolean | null;
    readonly portalPhaseStatusVisible: boolean | null;
  } | null;
  readonly customProjectId: string | null;
  readonly isInProjectGroup: boolean | null;
  readonly projectGroupId: string | null;
  readonly name: string | null;
  readonly budgetType: BUDGET_TYPE | null;
  readonly budget: number | null;
  readonly useBaseline: boolean | null;
  readonly defaultPeriodPeriodicity: PERIODICITY | null;
  readonly defaultPeriodLength: number | null;
  readonly defaultPeriodBudgetType: PERIOD_BUDGET_TYPE | null;
  readonly defaultPeriodHoursAmount: number | null;
  readonly defaultPeriodPriceAmount: number | null;
  readonly defaultPeriodSettingSubtractValue: boolean | null;
  readonly defaultPeriodSettingRollValue: boolean | null;
  readonly githubRepositoryIds: ReadonlyArray<number | null> | null;
  readonly useManualAllocations: boolean | null;
  readonly taskCostCalculationType: string | null;
  readonly unassignedTaskHourlyCost: number | null;
  readonly linkToPublicCreateTaskPage: string | null;
  readonly usePublicCreateTaskPassword: boolean | null;
  readonly publicCreateTaskPassword: string | null;
  readonly publicCreateTaskPageStatusColumn: {
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly manualProgressOnProjectEnabled: boolean | null;
  readonly manualProgressOnPhasesEnabled: boolean | null;
  readonly manualProgressOnTasksEnabled: boolean | null;
  readonly revenueMarginLow: number | null;
  readonly revenueMarginHigh: number | null;
  readonly hasInvoices: boolean | null;
  readonly hasLockedPeriod: boolean | null;
  readonly hasLockedTime: boolean | null;
  readonly userCanDeleteProject: boolean | null;
  readonly userCantDeleteProjectReason: CANT_DELETE_PROJECT_REASON | null;
  readonly baselineWinChance: number | null;
  readonly teamsId: string | null;
  readonly sageProject: {
    readonly id: string;
    readonly sageProjectId: string | null;
    readonly sageIntacctLocationEntityId: string | null;
  } | null;
  readonly currentProjectStatus: {
    readonly id: string;
    readonly color: string | null;
    readonly description: string | null;
    readonly day: number | null;
    readonly month: number | null;
    readonly year: number | null;
    readonly person: {
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly profilePictureId: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectStatus_projectStatus">;
  } | null;
  readonly projectStatuses: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly year: number | null;
        readonly month: number | null;
        readonly day: number | null;
        readonly hour: number | null;
        readonly minute: number | null;
        readonly second: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"ProjectStatus_projectStatus">;
      } | null;
    } | null> | null;
  } | null;
  readonly progressDetails: {
    readonly id: string;
    readonly progress: number | null;
    readonly createdAt: string | null;
    readonly createdBy: {
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly profilePictureId: string | null;
    } | null;
  } | null;
  readonly progressHistory: ReadonlyArray<{
    readonly id: string;
    readonly progress: number | null;
    readonly createdAt: string | null;
    readonly createdBy: {
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly profilePictureId: string | null;
    } | null;
  } | null> | null;
  readonly isProgramRevenueLocked: boolean | null;
  readonly programBudgetType: PROGRAM_BUDGET_TYPE | null;
  readonly programRemainingBudget: number | null;
  readonly program: {
    readonly name: string | null;
    readonly prefix: string | null;
    readonly totalAllocation: number | null;
    readonly budgetValue: number | null;
    readonly revenueSetting: string | null;
    readonly members: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly role: string | null;
          readonly person: {
            readonly id: string;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly harvestProject: {
    readonly id: string;
  } | null;
  readonly harvestProjectId: string | null;
  readonly jiraSyncRemaining: boolean | null;
  readonly jiraCloudProject: {
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly jiraServerProject: {
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly isJiraProject: boolean | null;
  readonly slackChannelId: string | null;
  readonly slackChannel: {
    readonly id: string;
  } | null;
  readonly salesforceOpportunity: string | null;
  readonly unit4Project: {
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly hubspotDeal: string | null;
  readonly pipedriveDeal: string | null;
  readonly vstsProject: string | null;
  readonly vstsAccount: string | null;
  readonly vstsArea: string | null;
  readonly vstsSyncBugs: boolean | null;
  readonly vstsTwoWaySync: boolean | null;
  readonly vstsUseEpics: boolean | null;
  readonly vstsUseNewSubtasks: boolean | null;
  readonly gitlabProjectId: string | null;
  readonly gitlabProjectName: string | null;
  readonly gitlabServerProjectId: string | null;
  readonly gitlabServerProjectName: string | null;
  readonly gitHubSyncTarget: number | null;
  readonly status: PROJECT_STATUS | null;
  readonly projectColor: string | null;
  readonly statusColumnsV2: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly category: STATUS_CATEGORY | null;
        readonly name: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly projectLabels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly label: {
          readonly id: string;
          readonly name: string | null;
          readonly color: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly description: string | null;
  readonly estimationUnit: string | null;
  readonly sprintTimeBox: boolean | null;
  readonly sprintLengthInDays: number | null;
  readonly projectStartYear: number | null;
  readonly projectStartMonth: number | null;
  readonly projectStartDay: number | null;
  readonly projectEndYear: number | null;
  readonly projectEndMonth: number | null;
  readonly projectEndDay: number | null;
  readonly taskLevels: number | null;
  readonly useTaskHierarchy: boolean | null;
  readonly useDeliverables: boolean | null;
  readonly minutesPerEstimationPoint: number | null;
  readonly billable: boolean | null;
  readonly remainingAutoCalculated: boolean | null;
  readonly useTaskOwner: boolean | null;
  readonly useTaskFollowers: boolean | null;
  readonly retainerPeriods: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null;
    } | null> | null;
  } | null;
  readonly projectPersons: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly isContactPerson: boolean | null;
        readonly role: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly person: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly fullName: string | null;
          readonly initials: string | null;
          readonly profiles: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string | null;
              } | null;
            } | null> | null;
          } | null;
          readonly permissions: ReadonlyArray<string | null> | null;
          readonly email: string | null;
          readonly profilePictureId: string | null;
          readonly profilePictureDefaultId: number | null;
          readonly active: boolean | null;
          readonly isViewer: boolean | null;
          readonly harvestUser: boolean | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly personLabels: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly label: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
        readonly relationType: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly rateCard: {
    readonly id: string;
    readonly currency: string | null;
    readonly disabledRoles: ReadonlyArray<{
      readonly id: string;
    } | null> | null;
  } | null;
  readonly client: {
    readonly id: string;
    readonly clientBillTos: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly clientId: string;
          readonly billTo: {
            readonly id: string;
          } | null;
          readonly billFrom: {
            readonly id: string;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly clientContact: {
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
  } | null;
  readonly tasks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly companyTaskId: number | null;
        readonly statusColumnV2: {
          readonly name: string | null;
          readonly category: STATUS_CATEGORY | null;
        } | null;
        readonly parentTaskId: string | null;
        readonly sageIntacctId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly projectBillTos: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly clientBillToId: string;
        readonly projectId: string;
        readonly clientId: string;
        readonly invoiced: boolean | null;
        readonly billTo: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly billFrom: {
          readonly id: string;
          readonly name: string;
          readonly integration: string;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPriorityDropdown_project" | "ProjectManualProgressConfiguration_project" | "ProjectHeader_project" | "SecondaryNavigation_project" | "ValueCalculations_project" | "JiraIntegrationSection_project">;
  readonly " $fragmentType": "ProjectSettingsPage_project";
};
export type ProjectSettingsPage_project$key = {
  readonly " $data"?: ProjectSettingsPage_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSettingsPage_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v11 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ProjectStatus_projectStatus"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "progress",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Person",
    "kind": "LinkedField",
    "name": "createdBy",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "storageKey": null
  }
],
v16 = [
  (v0/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projectStatuses"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projectPersons"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "client",
          "clientBillTos"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projectBillTos"
        ]
      }
    ]
  },
  "name": "ProjectSettingsPage_project",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectPriorityDropdown_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectManualProgressConfiguration_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectHeader_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SecondaryNavigation_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ValueCalculations_project"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPortalConfig",
      "kind": "LinkedField",
      "name": "portalConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showInClientPortal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "portalPhaseStatusVisible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInProjectGroup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectGroupId",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budget",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useBaseline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultPeriodPeriodicity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultPeriodLength",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultPeriodBudgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultPeriodHoursAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultPeriodPriceAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultPeriodSettingSubtractValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultPeriodSettingRollValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "githubRepositoryIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useManualAllocations",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskCostCalculationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unassignedTaskHourlyCost",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkToPublicCreateTaskPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usePublicCreateTaskPassword",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicCreateTaskPassword",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2",
      "kind": "LinkedField",
      "name": "publicCreateTaskPageStatusColumn",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manualProgressOnProjectEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manualProgressOnPhasesEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manualProgressOnTasksEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revenueMarginLow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revenueMarginHigh",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInvoices",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasLockedPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasLockedTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userCanDeleteProject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userCantDeleteProjectReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineWinChance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SageProjectType",
      "kind": "LinkedField",
      "name": "sageProject",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctLocationEntityId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectStatus",
      "kind": "LinkedField",
      "name": "currentProjectStatus",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "storageKey": null
        },
        (v11/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "projectStatuses",
      "args": null,
      "concreteType": "ProjectStatusTypeConnection",
      "kind": "LinkedField",
      "name": "__Project_projectStatuses_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectStatusTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectStatus",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v7/*: any*/),
                (v6/*: any*/),
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hour",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minute",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "second",
                  "storageKey": null
                },
                (v11/*: any*/),
                (v12/*: any*/)
              ],
              "storageKey": null
            },
            (v13/*: any*/)
          ],
          "storageKey": null
        },
        (v14/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectProgress",
      "kind": "LinkedField",
      "name": "progressDetails",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectProgress",
      "kind": "LinkedField",
      "name": "progressHistory",
      "plural": true,
      "selections": (v15/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isProgramRevenueLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "programBudgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "programRemainingBudget",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProgramType",
      "kind": "LinkedField",
      "name": "program",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "budgetValue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "revenueSetting",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectServiceProgramMemberTypeConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectServiceProgramMemberTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectServiceProgramMemberType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "role",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": (v16/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HarvestProjectType",
      "kind": "LinkedField",
      "name": "harvestProject",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraSyncRemaining",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraCloudProjectType",
      "kind": "LinkedField",
      "name": "jiraCloudProject",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JiraIntegrationSection_project"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraServerProjectType",
      "kind": "LinkedField",
      "name": "jiraServerProject",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJiraProject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slackChannelId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SlackChannelType",
      "kind": "LinkedField",
      "name": "slackChannel",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salesforceOpportunity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Unit4ProjectType",
      "kind": "LinkedField",
      "name": "unit4Project",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hubspotDeal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pipedriveDeal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vstsProject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vstsAccount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vstsArea",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vstsSyncBugs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vstsTwoWaySync",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vstsUseEpics",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vstsUseNewSubtasks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gitlabProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gitlabProjectName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gitlabServerProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gitlabServerProjectName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gitHubSyncTarget",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000000
        }
      ],
      "concreteType": "StatusColumnV2TypeConnection",
      "kind": "LinkedField",
      "name": "statusColumnsV2",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StatusColumnV2TypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StatusColumnV2",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v17/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "statusColumnsV2(first:1000000)"
    },
    {
      "alias": null,
      "args": (v18/*: any*/),
      "concreteType": "ProjectLabelTypeConnection",
      "kind": "LinkedField",
      "name": "projectLabels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectLabelTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Label",
                  "kind": "LinkedField",
                  "name": "label",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "projectLabels(first:10000)"
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimationUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sprintTimeBox",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sprintLengthInDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectStartYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectStartMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectStartDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectEndYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectEndMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectEndDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskLevels",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useTaskHierarchy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useDeliverables",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minutesPerEstimationPoint",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingAutoCalculated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useTaskOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useTaskFollowers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "RetainerPeriodTypeConnection",
      "kind": "LinkedField",
      "name": "retainerPeriods",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RetainerPeriodTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RetainerPeriodType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v16/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "retainerPeriods(first:1)"
    },
    {
      "alias": "projectPersons",
      "args": null,
      "concreteType": "ProjectPersonTypeConnection",
      "kind": "LinkedField",
      "name": "__Project_projectPersons_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPersonTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectPerson",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isContactPerson",
                  "storageKey": null
                },
                (v19/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fullName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "initials",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": (v18/*: any*/),
                      "concreteType": "ProfileTypeConnection",
                      "kind": "LinkedField",
                      "name": "profiles",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProfileTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Profile",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": (v2/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "profiles(first:10000)"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "permissions",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    (v10/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profilePictureDefaultId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "active",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isViewer",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "harvestUser",
                      "storageKey": null
                    },
                    (v19/*: any*/),
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 1000
                        }
                      ],
                      "concreteType": "PersonLabelTypeConnection",
                      "kind": "LinkedField",
                      "name": "personLabels",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PersonLabelTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PersonLabel",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Label",
                                  "kind": "LinkedField",
                                  "name": "label",
                                  "plural": false,
                                  "selections": (v2/*: any*/),
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "personLabels(first:1000)"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relationType",
                  "storageKey": null
                },
                (v12/*: any*/)
              ],
              "storageKey": null
            },
            (v13/*: any*/)
          ],
          "storageKey": null
        },
        (v14/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RateCard",
      "kind": "LinkedField",
      "name": "rateCard",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "disabledRoles",
          "plural": true,
          "selections": (v16/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Client",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "clientBillTos",
          "args": null,
          "concreteType": "ClientBillToTypeConnection",
          "kind": "LinkedField",
          "name": "__BillFrom_clientBillTos_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientBillToTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ClientBillTo",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v20/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BillTo",
                      "kind": "LinkedField",
                      "name": "billTo",
                      "plural": false,
                      "selections": (v16/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BillFrom",
                      "kind": "LinkedField",
                      "name": "billFrom",
                      "plural": false,
                      "selections": (v16/*: any*/),
                      "storageKey": null
                    },
                    (v12/*: any*/)
                  ],
                  "storageKey": null
                },
                (v13/*: any*/)
              ],
              "storageKey": null
            },
            (v14/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientContact",
      "kind": "LinkedField",
      "name": "clientContact",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100000
        }
      ],
      "concreteType": "TaskTypeConnection",
      "kind": "LinkedField",
      "name": "tasks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyTaskId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StatusColumnV2",
                  "kind": "LinkedField",
                  "name": "statusColumnV2",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v17/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "parentTaskId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sageIntacctId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "tasks(first:100000)"
    },
    {
      "alias": "projectBillTos",
      "args": null,
      "concreteType": "ProjectBillToTypeConnection",
      "kind": "LinkedField",
      "name": "__Project_projectBillTos_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectBillToTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectBillTo",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "clientBillToId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectId",
                  "storageKey": null
                },
                (v20/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoiced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BillTo",
                  "kind": "LinkedField",
                  "name": "billTo",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BillFrom",
                  "kind": "LinkedField",
                  "name": "billFrom",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "integration",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v12/*: any*/)
              ],
              "storageKey": null
            },
            (v13/*: any*/)
          ],
          "storageKey": null
        },
        (v14/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};
})();

(node as any).hash = "d958bb139c65499891ede10f1e3ce4e3";

export default node;
